import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import App from './App';
import { landingTheme } from './theme';

import '@fontsource-variable/fraunces';
import '@fontsource-variable/plus-jakarta-sans';
import '@fontsource-variable/jetbrains-mono';

import './i18n';
import i18n from './i18n';

// Sync HTML lang attribute with i18n locale
document.documentElement.lang = i18n.language || 'it';
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

const globalStyles = (
  <GlobalStyles
    styles={{
      ':root': {
        '--bg': '#F4EFE6',
        '--bg-deep': '#EDE6D9',
        '--ink': '#1A1814',
        '--ink-soft': '#4A4239',
        '--sun': '#D4763A',
        '--sun-deep': '#A85A26',
        '--leaf': '#2D4A2B',
        '--dust': '#B8A892',
      },
      body: {
        background: 'var(--bg)',
        color: 'var(--ink)',
        backgroundImage:
          // sottile texture noise SVG inline
          `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='400'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.1 0 0 0 0 0.094 0 0 0 0 0.078 0 0 0 0.035 0'/></filter><rect width='400' height='400' filter='url(%23n)'/></svg>")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '400px 400px',
      },
      '::selection': { background: 'var(--sun)', color: 'var(--bg)' },
      '@keyframes spinSlow': {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
      },
      '@keyframes spinReverse': {
        from: { transform: 'rotate(360deg)' },
        to: { transform: 'rotate(0deg)' },
      },
      '@keyframes wordReveal': {
        from: { opacity: 0, transform: 'translateY(28px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
      },
      '@keyframes fadeIn': {
        from: { opacity: 0, transform: 'translateY(12px)' },
        to: { opacity: 1, transform: 'translateY(0)' },
      },
    }}
  />
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={landingTheme}>
        <CssBaseline />
        {globalStyles}
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
